// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
div {
  color: rgba(255, 255, 255, 1);
}

.container {
  top: 0px;
  left: 0px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/header.css"],"names":[],"mappings":";AACA;EACE,6BAA6B;AAC/B;;AAEA;EACE,QAAQ;EACR,SAAS;AACX","sourcesContent":["\ndiv {\n  color: rgba(255, 255, 255, 1);\n}\n\n.container {\n  top: 0px;\n  left: 0px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
